const AUTH_SESSION_KEY = 'auth-session';

export function getSession() {
  try {
    const raw = localStorage.getItem(AUTH_SESSION_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (e) {
    return {};
  }
}

/**
 * Merge partial session data into localStorage.
 * Used by auth flows (login/register/me).
 */
export function setSession(update) {
  const prev = getSession();
  const next = { ...prev, ...(update || {}) };
  localStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(next));
  return next;
}

export function clearSession() {
  localStorage.removeItem(AUTH_SESSION_KEY);
}

